import * as Sentry from '@sentry/react';

export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return;

  Sentry.init({
    dsn,
    release: import.meta.env.VITE_COMMIT_SHA,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration(),
      // H-04 (SECURITY_AUDIT.md 09-08-2026). Antes esto corria con
      // maskAllText:false y blockAllMedia:false. En una herramienta de gestion
      // de proyectos de consultoria el DOM ES el dato confidencial: nombres de
      // clientes, descripciones de tareas, comentarios internos. Con el
      // enmascarado apagado, todo eso salia del perimetro hacia un tercero.
      // `beforeSend` NO alcanza para taparlo: los replays viajan por otro
      // pipeline y no pasan por ese hook.
      Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
    ],
    tracesSampleRate: 0.1,
    // Cero replays de sesiones sanas: solo se graba cuando hubo un error, que
    // es cuando el replay realmente aporta al diagnostico. Antes se grababa el
    // 10% de TODAS las sesiones, con o sin error.
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    beforeSend(event) {
      if (event.user?.email) event.user.email = '[scrubbed]';
      if (event.user?.ip_address) event.user.ip_address = undefined;
      if (event.breadcrumbs) {
        for (const bc of event.breadcrumbs) {
          if (bc.data?.email) bc.data.email = '[scrubbed]';
        }
      }
      return event;
    },
  });
}

export { Sentry };
